import { render, staticRenderFns } from "./generalBuy.vue?vue&type=template&id=5f57b62d"
import script from "./generalBuy.vue?vue&type=script&lang=js"
export * from "./generalBuy.vue?vue&type=script&lang=js"
import style0 from "./generalBuy.vue?vue&type=style&index=0&id=5f57b62d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports